import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/page-headline.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2474eb50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "headline__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "headline__image" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thumb = _resolveComponent("thumb")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["headline", _ctx.titlePipe(_ctx.content?.title).length < 50 ? 'headline--big' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: "h2 highlighted",
          innerHTML: _ctx.titlePipe(_ctx.content?.title)
        }, null, 8, _hoisted_3),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.content?.thumb)
        ? (_openBlock(), _createBlock(_component_thumb, {
            key: 0,
            file: _ctx.content.thumb,
            size: 'large'
          }, null, 8, ["file"]))
        : (_openBlock(), _createElementBlock("figure", _hoisted_5, _hoisted_7))
    ])
  ], 2))
}